import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Grid from '@material-ui/core/Grid';

import { Field, Fields } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';
import OrderInformationSection from 'components/workflow/OrderInformation/OrderInformationSection';
import OrderInformationSectionTitle from 'components/workflow/OrderInformation/OrderInformationSectionTitle';

import * as validate from 'utils/validate';

import transmissionMethods from 'config/transmissionMethods';

import {
  requestFetchFacilities,
  requestSearchFacilities,
} from 'redux/modules/facilities';
import { accountLoginFail } from 'redux/modules/account';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';

import OrderInformationGeneralInsuranceFields from './OrderInformationGeneralInsuranceFields';

const OrderInformationGeneral = ({
  change, formValues, account, actions, systemSettings, disabled, ...otherProps
}) => (
  <OrderInformationSection>
    <Grid
      container
      justify="flex-start"
      spacing={16}
    >
      <Grid
        item
        xs={12}
      >
        <OrderInformationSectionTitle title="Facility" />
        <Field
          id="Company Name"
          name="Company Name"
          component={AutosuggestField}
          validate={[validate.required]}
          placeholder="-Select Facility-"
          fullWidth
          renderSuggestionContent={suggestion => suggestion['Company Info']['Company Name']}
          onSuggestionSelected={(suggestion) => {
            change('Facility ID', suggestion.ID);
            change('Selected Company Name', suggestion['Company Info']['Company Name']);
            return suggestion['Company Info']['Company Name'];
          }}
          fetchSuggestions={({ value, limit, offset }) => (
            value.length > 0
              ? requestSearchFacilities({
                filters: [
                  {
                    name: 'Facility Name',
                    operation: 'startswith',
                    val: value,
                    case_sensitivity: false,
                  },
                ],
                limit,
                offset,
              }).then(res => res.data,
                (error) => {
                  if (error.data.error === 'Access Error') {
                    actions.saveRecoverOrder({
                      [account.ID]: {
                        ...formValues,
                        timestamp: new Date().getTime(),
                      },
                    });
                    actions.accountLoginFail();
                  }
                  return error;
                })
              : requestFetchFacilities({
                limit,
                offset,
              }).then(res => res.data,
                (error) => {
                  if (error.data.error === 'Access Error') {
                    actions.saveRecoverOrder({
                      [account.ID]: {
                        ...formValues,
                        timestamp: new Date().getTime(),
                      },
                    });
                    actions.accountLoginFail();
                  }
                  return error;
                })
          )}
          disabled={disabled}
        />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <OrderInformationSectionTitle title="Transmission Method" />
        <Field
          id="Transmission Method"
          name="Transmission Method"
          component={AutosuggestField}
          validate={[validate.required]}
          placeholder="-Select Transmission Method-"
          fullWidth
          renderSuggestionContent={suggestion => suggestion}
          onSuggestionSelected={suggestion => suggestion}
          fetchSuggestions={({ value }) => (new Promise((resolve) => {
            if (value.length > 0) {
              resolve(transmissionMethods
                .filter(item => item.toLowerCase().indexOf(value.toLowerCase()) !== -1));
            } else {
              resolve(transmissionMethods);
            }
          }))}
          disabled={disabled}
        />
      </Grid>
      <Fields
        names={[
          'Transmission Method',
          'Insurances',
          'Order Insurance Param',
          'Authorization',
          'Authorization From',
          'Authorization To',
          'Resubmission',
          'Original Ref Number',
        ]}
        component={OrderInformationGeneralInsuranceFields}
        insuranceInformation={otherProps['Insurance Information']}
        systemSettings={systemSettings}
        disabled={disabled}
      />
    </Grid>
  </OrderInformationSection>
);

OrderInformationGeneral.propTypes = {
  change: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    'Transmission Method': PropTypes.string,
  }),
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  systemSettings: PropTypes.object,
};

OrderInformationGeneral.defaultProps = {
  Facility: null,
  formValues: {},
  systemSettings: {},
  disabled: false,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail, saveRecoverOrder }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderInformationGeneral);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationGeneral/OrderInformationGeneral.js